<loader *ngIf="isLoading"></loader>
<ng-container *ngIf="newCatSystemVersion(catSystemVersion) && groups && groups.length > 0">    
    <div class="t-panel-cell">
        <div>

            <ng-container *ngFor="let group of groups">


                <input-wrap [label]="group.groupLabel" cssClass="l-cell-spread" [required]="group.isRequired">
                    <div style="display: flex">
                        <ng-container *ngIf="group.isMultiValued; else singleValue">
                            @let isDisabled = (claimBulkDocMetadataHandler.hasLock(group.groupName) && claimBulkDocMetadataHandler.getLockValue(group.groupName)) || (claimBulkDocMetadataHandler.isFormControlDisabled(group)); 

                            <p-multiSelect [options]="docMetadataByGroup[group.groupName]" class="l-cell-spread-x"
                                [(ngModel)]="selections[group.groupName]" optionLabel="fieldLabel" [filter]="true"
                                [disabled]="isDisabled"
                                [showClear]="!group.isRequired" appendTo="body" [resetFilterOnHide]="true" [autofocusFilter]="true"
                                (onChange)="changeSelection(group)"
                                (onClear)="changeSelection(group)"
                                filterBy="fieldLabel">
                            </p-multiSelect>
                        </ng-container>

                        <ng-template #singleValue>
                            @let isDisabled = (claimBulkDocMetadataHandler.hasLock(group.groupName) && claimBulkDocMetadataHandler.getLockValue(group.groupName)) || (claimBulkDocMetadataHandler.isFormControlDisabled(group)); 
                            <p-select [options]="docMetadataByGroup[group.groupName]" class="l-cell-spread-x" [ngClass]="isDisabled ? 'multi-select-disabled' : ''"
                                [disabled]="isDisabled"
                                appendTo="body" [showClear]="true" [(ngModel)]="selections[group.groupName]"
                                (onChange)="changeSelection(group)"
                                [showClear]="!group.isRequired"
                                optionLabel="fieldLabel">
                            </p-select>
                        </ng-template>
                        <ng-container *ngIf="claimBulkDocMetadataHandler.hasLock(group.groupName)">
                            <p-button severity="secondary" [text]="true" size="small" (click)="toggleLockValue(group)" [title]="
                              claimBulkDocMetadataHandler.getLockValue(group.groupName)
                                ? ('translate.general.unlockField' | translate)
                                : ('translate.general.lockAndResetField' | translate)
                            " [icon]="claimBulkDocMetadataHandler.getLockValue(group.groupName) ? 'fa-solid fa-lock': 'fa-solid fa-lock-open'">
                            </p-button>
                        </ng-container>
                    </div>

                </input-wrap>

            </ng-container>
        </div>
    </div>
</ng-container>